import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paywebfailed',
  templateUrl: './paywebfailed.component.html',
  styleUrls: ['./paywebfailed.component.css']
})
export class PaywebfailedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
